<template>

    <v-menu
        v-if="hasVitalParametersForm"
        v-model="mustShowVitalParamsForm"
        ref="vitalParamsDropdownMenu"
        id="vitalParamsDropdownMenu"
        :nudge-width="320"
        class="menu-settings"
        bottom
        nudge-left="50"
        nudge-top="-50"
        offset-x
        :close-on-click="false"
        :close-on-content-click="false"
    >
        <svg-button
            ref="btnShowVitalParamsCard"
            id="btnShowVitalParamsCard"
            slot="activator"
            :margin-left="10"
            :margin-right="10"
            @click.native="toggleDropdown"
        >
            <vital-parameters-icon></vital-parameters-icon>
        </svg-button>

        <v-card
                id="vitalParamsDropdownCard"
                :class="{'vital-params-dropdown-card--selected': shortcutNav.selectedDropdown }"
                class="vital-params-dropdown-card dropdown-card"
                @click.native="handleClickInsideDropdown($event)"
        >

            <v-list class="account-settings">
                <div class="vital-params-dropdown-card-title">
                    <h4 class="title-assessment-sections">{{text('api.pro.vital.parameters.form.title')}}</h4>
                </div>
                <v-divider></v-divider>

                <v-form :value="isVitalParamsFormValid" ref="vitalParamsForm" id="vitalParamsForm">

                    <p v-if="this.getVitalParameters.generalValidationError && this.getVitalParameters.generalValidationError.validationError" class="color-error">{{this.getVitalParameters.generalValidationError.validationError}}</p>

                    <div v-for="(vitalParam, index) in vitalParamList"
                         v-if="vitalParam.group === null"
                         :ref="'fieldWrapperVitalParams_' + vitalParam.name"
                         :id="'fieldWrapperVitalParams_' + vitalParam.name"
                         class="vital-params-field-wrapper margin-bottom-m"
                    >
                        <p class="vital-params-label">{{$text('api.pro.vital.parameters.label.'+ vitalParam.name)}}</p>

                        <v-text-field
                            autocomplete="off"
                            :ref="'fieldVitalParams_' + vitalParam.name"
                            :id="'fieldVitalParams_' + vitalParam.name"
                            :value="vitalParam.value"
                            @click="handleInputFieldClicks('fieldVitalParams_' + vitalParam.name)"
                            :class="{
                                'input-group--focused': (isNavAvailable && shortcutNav.crtField === 'fieldVitalParams_' + vitalParam.name),
                                'input-group--not-focused': (!isNavAvailable),
                            }"
                            v-model="vitalParam.value"
                            :disabled="isVitalParamsAjaxInProgress"
                            :error-messages="(vitalParam.validationError !== null) ? vitalParam.validationError : []"
                        >
                        </v-text-field>
                    </div>

                    <v-container v-if="getVitalParametersGroups && Object.keys(getVitalParametersGroups).length > 0"
                                 id="vitalParamsGroupContainer"
                                 ref="vitalParamsGroupContainer"
                                 class="vital-params-group-container"
                                 grid-list-md
                    >
                        <v-layout v-for="vitalParamGroup in getVitalParametersGroups"
                                  :id="'vitalParamsGroup_' + vitalParamGroup.groupName"
                                  :ref="'vitalParamsGroup_' + vitalParamGroup.groupName"
                                  :key="'vitalParamsGroup_' + vitalParamGroup.groupName"
                                  class="vital-params-group"
                                  row
                        >

                            <v-flex v-if="vitalParamGroup.vitalParameters.length > 0" class="vital-params-group--input no-padding" xs6>

                                <div :id="'fieldWrapperVitalParamsGroup_' + vitalParamGroup.groupName"
                                     :ref="'fieldWrapperVitalParamsGroup_' + vitalParamGroup.groupName"
                                     class="vital-params-field-wrapper vital-params-field-wrapper--group vital-params-field-wrapper--group--text margin-bottom-m"
                                >
                                    <p class="vital-params-label">{{$text('api.pro.vital.parameters.label.' + vitalParamGroup.selectedVitalParamName)}}&nbsp;</p>

                                    <v-text-field
                                        autocomplete="off"
                                        :ref="'fieldVitalParamsGroup_' + vitalParamGroup.groupName"
                                        :id="'fieldVitalParamsGroup_' + vitalParamGroup.groupName"
                                        :value="vitalParamGroup.value"
                                        v-model="vitalParamGroup.value"
                                        @click="handleInputFieldClicks('fieldVitalParamsGroup_' + vitalParamGroup.groupName)"
                                        :class="{
                                            'input-group--focused': (isNavAvailable && shortcutNav.crtField === 'fieldVitalParamsGroup_' + vitalParamGroup.groupName),
                                            'input-group--not-focused': (!isNavAvailable)
                                        }"
                                        :disabled="isVitalParamsAjaxInProgress"
                                        :error-messages="(vitalParamGroup.validationError !== null) ? vitalParamGroup.validationError : []"
                                    >
                                    </v-text-field>
                                </div>

                            </v-flex>
                            <v-flex v-if="vitalParamGroup.vitalParameters.length > 0" class="vital-params-group--select no-padding" xs6>
                                <div class="vital-params-field-wrapper vital-params-field-wrapper--group vital-params-field-wrapper--group--select margin-bottom-m">
                                    <p class="vital-params-label">&nbsp;</p>

                                    <v-select
                                        :ref="'vitalParamsGroup_fieldSelector_' + vitalParamGroup.groupName"
                                        :id="'vitalParamsGroup_fieldSelector_' + vitalParamGroup.groupName"
                                        :items="vitalParamGroup.vitalParameters"
                                        item-text="label"
                                        item-value="name"
                                        v-model="vitalParamGroup.selectedVitalParamName"
                                        @change="handleSelectFieldInGroup($event, vitalParamGroup.groupName)"
                                        :class="{'question-highlighted': (isNavAvailable === true && shortcutNav.crtField === 'vitalParamsGroup_fieldSelector_' + vitalParamGroup.groupName)}"
                                        :disabled="vitalParamGroup.hasValidationErrors"
                                        single-line
                                        auto
                                        :append-icon="null"
                                        hide-details
                                        class="select-value vital-params"
                                        color="primary"
                                    >
                                    </v-select>
                                    <div @click="clickSelect(vitalParamGroup.groupName)" style="position: absolute; right: 20px; bottom: 0; cursor: pointer">
                                        <ArrowDownIcon class="select-arrow-down" :class="{'select-arrow-up': getMenuIsActive(vitalParamGroup.groupName)}" :height="24" :width="24"  />
                                    </div>

                                </div>

                            </v-flex>
                        </v-layout>
                    </v-container>

                </v-form>

            </v-list>
        </v-card>

    </v-menu>


</template>

<script>
const VITAL_PARAMS_INPUT_FIELD_PREFIX = 'fieldVitalParams_';
const VITAL_PARAMS_GROUP_INPUT_FIELD_PREFIX = 'fieldVitalParamsGroup_';
const VITAL_PARAMS_GROUP_FIELD_SELECTOR_PREFIX = 'vitalParamsGroup_fieldSelector_';

import {mapGetters} from "vuex";
import SvgButton from "../../../common/components/shared/SvgButton";
import VitalParametersIcon from "../../../common/components/svg/shared/vitalParametersIcon";
import ArrowDownIcon from "../../../common/components/svg/shared/arrowDownIcon.vue";


export default {
    name: "VitalParamsDropdownForm",
    components: {ArrowDownIcon, SvgButton, VitalParametersIcon},
    props: ["pageShortcutNav"],
    data () {
        return {
            isVitalParamsAjaxInProgress: false,
            shortcutNav: {
                crtField: null,
                crtFieldInEdit: false,
                selectedDropdown: false,
                selectIsOpen: false,
            },
        }
    },

    computed: {
        ...mapGetters({
            getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
            getVitalParameters: 'VitalParametersStore/getVitalParameters',
            getVitalParametersGroups: 'VitalParametersStore/getVitalParametersGroups',
            getInvalidVitalParams: 'VitalParametersStore/getInvalidVitalParams',
            getMustShowVitalParamsForm: 'VitalParametersStore/getMustShowVitalParamsForm',
            getMustFocusVitalParameter: 'VitalParametersStore/getMustFocusVitalParameter',
            getFocusVitalParameter: 'VitalParametersStore/getFocusVitalParameter',
            mustShowUrgentPopup: 'AssessmentAlertsStore/getMustShowUrgentPopup',
        }),

        vitalParamList() {
            return this.getVitalParameters.vitalParameters;
        },

        navVitalParamList() {
            return this.getVitalParameters.vitalParameters.filter((vitalParam) => {
                return vitalParam.group === null;
            })
        },

        navVitalParamGroupsList() {
            let vitalParamGroups = [];

            Object.keys(this.getVitalParametersGroups).forEach((vitalParamGroup) => {
                let vitalParamGroupInput = {}
                vitalParamGroupInput['name'] = VITAL_PARAMS_GROUP_INPUT_FIELD_PREFIX + vitalParamGroup;
                vitalParamGroups.push(vitalParamGroupInput);

                let vitalParamGroupSelect = {}
                vitalParamGroupSelect['name'] = VITAL_PARAMS_GROUP_FIELD_SELECTOR_PREFIX + vitalParamGroup;
                vitalParamGroups.push(vitalParamGroupSelect);
            });


            return vitalParamGroups;
        },

        navIsCrtFieldGroup() {
            if (this.shortcutNav.crtField === null) {
                return false;
            }
            return this.shortcutNav.crtField.indexOf('ParamsGroup') !== -1;
        },

        mustShowVitalParamsForm: {
            get() {
                return this.getMustShowVitalParamsForm;
            },
            set(newValue) {
                if (newValue === false) {
                    this.toggleDropdown();
                }
            }
        },

        hasVitalParametersForm() {
            const routesWithVitalParamsForm = [
                'AssessmentStartPage',
                'AssessmentStartListPage',
                'ChooseMainSymptomPage',
                'SymptomsQuestionsPage',
                'AssessmentSymptomsPriorityListPage'
            ];
            return this.getAppPropertyValue('PARAM_TABLE_ENABLED') === 'true'
                && this.getVitalParameters !== null
                && this.getVitalParameters.vitalParameters !== null
                && routesWithVitalParamsForm.indexOf(this.$route.name) > -1;
        },

        changedVitalParam() {

            if (this.vitalParamList.length === 0) {
                return null;
            }

            const changedVitalParam = this.vitalParamList.find((vitalParam) => {
                return (vitalParam.value !== vitalParam.initialValue) ? true : false;
            });

            if (typeof changedVitalParam === 'object' && changedVitalParam !== null) {
                return changedVitalParam;
            }
            else {
                return null;
            }
        },

        changedVitalParamGroup() {

            if (Object.keys(this.getVitalParametersGroups).length === 0) {
                return null;
            }

            const changedVitalParamGroupName = Object.keys(this.getVitalParametersGroups).find((vitalParamGroupName) => {
                const vitalParamGroup = this.getVitalParametersGroups[vitalParamGroupName];
                return (vitalParamGroup.value !== vitalParamGroup.initialValue
                        || vitalParamGroup.selectedVitalParamName !== vitalParamGroup.initialSelectedVitalParamName)
                            ? true : false;
            });

            if (typeof changedVitalParamGroupName === 'string'
                    && typeof this.getVitalParametersGroups[changedVitalParamGroupName] === 'object'
                    && this.getVitalParametersGroups[changedVitalParamGroupName] !== null) {
                return this.getVitalParametersGroups[changedVitalParamGroupName];
            }
            else {
                return null;
            }
        },

        isVitalParamsFormValid() {
            return (this.getInvalidVitalParams.length === 0) ? true : false;
        },

        // Checks if the keyboard navigation is enabled for the current page
        isNavAvailable() {
            // We check to see if the keyboard navigation is enabled for the current page
            return (this.pageShortcutNav != null && this.pageShortcutNav.isKeyboardNav === true);
        }

    },

    created() {
        window.addEventListener('keydown', this.handleKeyDowns);
        window.addEventListener('keyup', this.handleKeyUps);

        window.addEventListener('click', this.handleClickOutsideDropdown);
    },
    destroyed() {
        window.removeEventListener('keydown', this.handleKeyDowns);
        window.removeEventListener('keyup', this.handleKeyUps);

        window.removeEventListener('click', this.handleClickOutsideDropdown);
    },

    methods: {

        submitVitalParameter(paramObj) {

            this.isVitalParamsAjaxInProgress = true;
            const promiseVitalParamSubmitted = this.$store.dispatch('VitalParametersStore/submitVitalParameterValue', {
                vitalParam: {
                    name: paramObj.name,
                    value: paramObj.value,
                },
                currentRoute: this.$router.currentRoute
            }).then((response) => {
                this.isVitalParamsAjaxInProgress = false;
            });

            return promiseVitalParamSubmitted;
        },

        handleClickInsideDropdown(event) {

            // Disable keyboard navigation
            this.$emit('setIsKeyboardNav', false);

            const VITAL_PARAM_FIELD_ID_PREFIX = "fieldVitalParams_";
            const VITAL_PARAM_GROUP_FIELD_ID_PREFIX = "fieldVitalParamsGroup_";

            const clickedElemId = event.target.id;

            // Checks if the clicked element is a vital parameters input field:
            const isClickedAVitalParamField = (clickedElemId.indexOf(VITAL_PARAM_FIELD_ID_PREFIX) === 0) ? true : false;
            // Checks if the clicked element is a vital parameters group input field:
            const isClickedAVitalParamGroupField = (clickedElemId.indexOf(VITAL_PARAM_GROUP_FIELD_ID_PREFIX) === 0) ? true : false;

            // If we click inside the dropdown, but the clicked element is not a vital parameters input field, then se set the crtFieldInEdit to false
            if (isClickedAVitalParamField === false && isClickedAVitalParamGroupField === false) {
                this.shortcutNav.crtFieldInEdit = false;
            }

            // Check if the clicked element is the vital parameters input field that has been changed
            // (so check if the user clicked on the same input that is currently being changed):
            const isClickedTheChangedVitalParamField = (
                isClickedAVitalParamField
                && this.changedVitalParam !== null
                && clickedElemId === VITAL_PARAM_FIELD_ID_PREFIX + this.changedVitalParam.name
            ) ? true : false;

            // Check if the clicked element is the vital parameters input field that has been changed
            // (so check if the user clicked on the same input that is currently being changed):
            const isClickedTheChangedVitalParamGroupField = (
                isClickedAVitalParamGroupField
                && this.changedVitalParamGroup !== null
                && clickedElemId === VITAL_PARAM_GROUP_FIELD_ID_PREFIX + this.changedVitalParamGroup.groupName
            ) ? true : false;

            if (this.changedVitalParam !== null && !isClickedTheChangedVitalParamField) {
                this.submitVitalParameter(this.changedVitalParam).then(() => {

                    if (isClickedAVitalParamField) {
                        event.target.focus(); // Keep the focus on the clicked input.
                    }

                });
            }
            else if (this.changedVitalParamGroup !== null && !isClickedTheChangedVitalParamGroupField) {
                this.submitVitalParameter({
                    name: this.changedVitalParamGroup.selectedVitalParamName,
                    value: this.changedVitalParamGroup.value
                }).then(() => {

                    if (isClickedAVitalParamField) {
                        event.target.focus(); // Keep the focus on the clicked input.
                    }

                });
            }

        },

        handleClickOutsideDropdown(event) {
            const target = event.target;

            if (!this.mustShowVitalParamsForm || target.className !== 'vital-params-form-overlay overlay overlay--active') {
                return;
            }

            if (this.mustShowUrgentPopup === true || this.getMustFocusVitalParameter) {
                return;
            }
            if (this.getMustShowVitalParamsForm === true) {

                if (this.changedVitalParam !== null) {
                    this.submitVitalParameter(this.changedVitalParam).then((response) => {
                        if (this.isVitalParamsFormValid === true) {
                            this.closeDropdown();
                        }
                    });
                }
                else if (this.changedVitalParamGroup !== null) {
                    this.submitVitalParameter({
                        name: this.changedVitalParamGroup.selectedVitalParamName,
                        value: this.changedVitalParamGroup.value
                    }).then((response) => {
                        if (this.isVitalParamsFormValid === true) {
                            this.closeDropdown();
                        }
                    })
                }
                else {
                    if (this.isVitalParamsFormValid === true) {
                        this.closeDropdown();
                    }
                }
            }
        },

        handleSelectFieldInGroup(newSelectedValue, vitalParamGroupName) {

            if (vitalParamGroupName != null && newSelectedValue != null) {
                this.$store.commit('VitalParametersStore/setSelectedVitalParamInGroup', {
                    groupName: vitalParamGroupName,
                    newSelectedVitalParamName: newSelectedValue
                });
                this.submitVitalParameter({
                    name: this.getVitalParametersGroups[vitalParamGroupName].selectedVitalParamName,
                    value: this.getVitalParametersGroups[vitalParamGroupName].value
                });
            }
        },

        openDropdown() {
            this.$store.commit('VitalParametersStore/setMustShowVitalParamsForm', true);
        },
        closeDropdown() {
            this.$store.commit('VitalParametersStore/setMustShowVitalParamsForm', false);
        },
        toggleDropdown() {
            if (this.getMustShowVitalParamsForm === true) {
                // CLOSE.
                if (this.changedVitalParam !== null) {
                    this.submitVitalParameter(this.changedVitalParam).then(() => {
                        if (this.isVitalParamsFormValid) {
                            this.closeDropdown();
                        }
                    });
                }
                else {
                    if (this.isVitalParamsFormValid) {
                        this.closeDropdown();
                    }
                }
            }
            else {
                // OPEN.
                this.openDropdown();
            }
        },

        clickSelect(groupName) {
            const select = this.$refs['vitalParamsGroup_fieldSelector_' + groupName][0];
            if (select != null) {
                if (!select.menuIsActive) {
                    select.$el.focus();
                    select.showMenu();
                    // select.setMenuIndex(0);
                }
            }
        },

        getMenuIsActive(groupName) {
            if (this.$refs['vitalParamsGroup_fieldSelector_' + groupName] != null) {
                if (this.$refs['vitalParamsGroup_fieldSelector_' + groupName][0] != null) {
                    return this.$refs['vitalParamsGroup_fieldSelector_' + groupName][0].menuIsActive
                }
            }

        },

        /*******************************
         ***   KEYBOARD NAVIGATION   ***
         ***      BEGIN CODE         ***
         *******************************/

        // Selects the next input field in the vital parameters form.
        navSelectNextInputField() {
            let currentIdx = -1;

            // If we don't have keyboard navigation enabled then enable it.
            if (!this.isNavAvailable) {
                this.$emit('setIsKeyboardNav', true);
                this.navScrollInputFieldIntoView();
                return;
            }

            // If the current field is not part of any group we are navigating through the vital parameters inputs
            if (this.navIsCrtFieldGroup === false) {
                // Find the index of the current field before choosing the next one
                currentIdx = this.navVitalParamList.findIndex((vitalParam) => {
                    return VITAL_PARAMS_INPUT_FIELD_PREFIX + vitalParam.name === this.shortcutNav.crtField;
                });

                if (this.navVitalParamList.length <= (currentIdx + 1)) {
                    // We have reached the last field form the vitalParams.
                    // The next one might belong to a group if we have groups, or choose the first vitalParam.
                    currentIdx = 0;
                    // If we have vitalParamsGroups, then select the first vitalParamGroup
                    if (Object.keys(this.getVitalParametersGroups).length > 0) {
                        this.shortcutNav.crtField = this.navVitalParamGroupsList[currentIdx].name;
                    }
                    else {
                        // If we don't have vitalParamsGroups, then select the first vitalParam
                        this.shortcutNav.crtField = VITAL_PARAMS_INPUT_FIELD_PREFIX + this.navVitalParamList[currentIdx].name;
                    }

                }
                else {
                    // Else select the next field
                    this.shortcutNav.crtField = VITAL_PARAMS_INPUT_FIELD_PREFIX + this.navVitalParamList[currentIdx + 1].name;
                }
            }
            // The current field is part of a group
            else {
                // Find the index of the current field before choosing the next one
                currentIdx = this.navVitalParamGroupsList.findIndex((vitalParamGroup) => {
                    return vitalParamGroup.name === this.shortcutNav.crtField;
                });

                // When pressing arrow down on a field that belongs to a group we try to go down, skipping the field that is positioned right/left to the current one
                // That is why we go currentIdx + 2
                if (this.navVitalParamGroupsList.length <= (currentIdx + 2)) {
                    // We have reached the last field form the vitalParamsGroups.
                    // The next one might belong to the vitalParams if we have vitalParams, or choose the first vitalParamGroup.
                    currentIdx = 0;
                    if (this.navVitalParamList.length > 0) {
                        // If we have vitalParams, then select the first one
                        this.shortcutNav.crtField = VITAL_PARAMS_INPUT_FIELD_PREFIX + this.navVitalParamList[currentIdx].name;
                    }
                    else {
                        // We don't have vitalParams, then select the first vitalParamGroup
                        this.shortcutNav.crtField = this.navVitalParamGroupsList[currentIdx].name;
                    }
                }
                else {
                    // Else select the field that is positioned bottom to the current one
                    this.shortcutNav.crtField = this.navVitalParamGroupsList[currentIdx + 2].name;
                }
            }

            // Scroll the selected field into view
            this.navScrollInputFieldIntoView();
        },

        // Selects the previous input field in the vital parameters form.
        navSelectPreviousInputField() {
            let currentIdx = -1;

            // If we don't have keyboard navigation enabled then enable it.
            if (!this.isNavAvailable) {
                this.$emit('setIsKeyboardNav', true);
                this.navScrollInputFieldIntoView();
                return;
            }

            // If the current field is not part of any group we are navigating through the vital parameters inputs
            if (this.navIsCrtFieldGroup === false) {
                // Find the index of the current field before choosing the next one
                currentIdx = this.navVitalParamList.findIndex((vitalParam) => {
                    return VITAL_PARAMS_INPUT_FIELD_PREFIX + vitalParam.name === this.shortcutNav.crtField;
                });

                if ((currentIdx - 1) < 0) {
                    // We have reached the first field from the vitalParams.
                    // The previous one might belong to a group if we have groups, or choose the last vitalParam.
                    // If we have vitalParamsGroups, then select the first vitalParamGroup
                    if (Object.keys(this.getVitalParametersGroups).length > 0) {
                        // If we have at least 1 group, then the navVitalParamGroupsList will always have at least 2 elements (see computed property navVitalParamGroupsList)
                        // That's why we don't need to check if the currentIdx might be -1 (which is not possible)
                        currentIdx = this.navVitalParamGroupsList.length - 2;
                        this.shortcutNav.crtField = this.navVitalParamGroupsList[currentIdx].name;
                    }
                    else {
                        // If we don't have vitalParamsGroups, then select the last vitalParam
                        currentIdx = this.navVitalParamList.length - 1;
                        this.shortcutNav.crtField = VITAL_PARAMS_INPUT_FIELD_PREFIX + this.navVitalParamList[currentIdx].name;
                    }

                }
                else {
                    // Else select the next field
                    this.shortcutNav.crtField = VITAL_PARAMS_INPUT_FIELD_PREFIX + this.navVitalParamList[currentIdx - 1].name;
                }
            }
            // The current field is part of a group
            else {
                // Find the index of the current field before choosing the next one
                currentIdx = this.navVitalParamGroupsList.findIndex((vitalParamGroup) => {
                    return vitalParamGroup.name === this.shortcutNav.crtField;
                });
                // When pressing arrow up on a field that belongs to a group we try to go up, skipping the field that is positioned right/left to the current one
                if ((currentIdx - 2) < 0) {
                    // We have reached the first field from the vitalParamsGroups.
                    // The previous one might belong to the vitalParams if we have vitalParams, or choose the last vitalParamGroup.

                    if (this.navVitalParamList.length > 0) {
                        // If we have vitalParams, then select the last one
                        currentIdx = this.navVitalParamList.length - 1;
                        this.shortcutNav.crtField = VITAL_PARAMS_INPUT_FIELD_PREFIX + this.navVitalParamList[currentIdx].name;
                    }
                    else {
                        // We don't have vitalParams, then select the last vitalParamGroup that is an input field (this means we skip the last select)
                        currentIdx = this.navVitalParamGroupsList.length - 2;
                        this.shortcutNav.crtField = this.navVitalParamGroupsList[currentIdx].name;
                    }
                }
                else {
                    // Else select the field that is positioned top to the current one
                    this.shortcutNav.crtField = this.navVitalParamGroupsList[currentIdx - 2].name;
                }
            }

            // Scroll the selected field into view
            this.navScrollInputFieldIntoView();
        },

        // Selects the first input field in the vital parameters form.
        navSelectFirstInputField() {
            // If we have a current field in edit do nothing
            if (this.shortcutNav.crtFieldInEdit === true || this.shortcutNav.selectIsOpen === true) {
                return;
            }

            // Select the first field
            // If we have vitalParams, then select the first one
            if (this.navVitalParamList.length > 0) {
                this.shortcutNav.crtField = VITAL_PARAMS_INPUT_FIELD_PREFIX + this.navVitalParamList[0].name;
            }
            else {
                // We don't have vitalParams, then select the first vitalParamGroup
                this.shortcutNav.crtField = this.navVitalParamGroupsList[0].name;
            }

            // Scroll the selected field into view
            this.navScrollInputFieldIntoView();
        },

        // Selects the last input field in the vital parameters form.
        navSelectLastInputField() {
            // If we have a current field in edit do nothing
            if (this.shortcutNav.crtFieldInEdit === true || this.shortcutNav.selectIsOpen === true) {
                return;
            }

            // Select the last field
            // If we have vitalParamsGroups, then select the last one
            if (this.navVitalParamGroupsList.length > 0) {
                this.shortcutNav.crtField = this.navVitalParamGroupsList[this.navVitalParamGroupsList.length - 2].name;
            }
            else {
                // Else select the last vitalParam
                this.shortcutNav.crtField = VITAL_PARAMS_INPUT_FIELD_PREFIX + this.navVitalParamList[this.navVitalParamList.length - 1].name;
            }

            // Scroll the selected field into view
            this.navScrollInputFieldIntoView();
        },

        // Select the input/select to the left of the current vitalParamGroup field
        navSelectLeftField() {
            // We select the left field only if we are not editing a field or if the current field is part of a group
            if (this.shortcutNav.crtFieldInEdit === true || this.navIsCrtFieldGroup === false || this.shortcutNav.selectIsOpen === true) {
                return;
            }

            // Find the index of the current field before choosing the next one
            let currentIdx = this.navVitalParamGroupsList.findIndex((vitalParamGroup) => {
                return vitalParamGroup.name === this.shortcutNav.crtField;
            });

            // If we are on the input and we go left, then go right (circular navigation in a group)
            if (this.shortcutNav.crtField.indexOf('fieldSelector') === -1) {
                this.shortcutNav.crtField = this.navVitalParamGroupsList[currentIdx + 1].name;
                return;
            }

            // We can go left
            this.shortcutNav.crtField = this.navVitalParamGroupsList[currentIdx - 1].name;

            // Scroll the input into view
            this.navScrollInputFieldIntoView();
        },

        // Select the input/select to the left of the current vitalParamGroup field
        navSelectRightField() {
            // We select the left field only if we are not editing a field or if the current field is part of a group
            if (this.shortcutNav.crtFieldInEdit === true || this.navIsCrtFieldGroup === false || this.shortcutNav.selectIsOpen === true) {
                return;
            }

            // Find the index of the current field before choosing the next one
            let currentIdx = this.navVitalParamGroupsList.findIndex((vitalParamGroup) => {
                return vitalParamGroup.name === this.shortcutNav.crtField;
            });

            // If we are positioned on a select and we go right, then go left (circular navigation in a group)
            if (this.shortcutNav.crtField.indexOf(VITAL_PARAMS_GROUP_FIELD_SELECTOR_PREFIX) !== -1) {
                this.shortcutNav.crtField = this.navVitalParamGroupsList[currentIdx - 1].name;
                return;
            }
            // We can go right
            this.shortcutNav.crtField = this.navVitalParamGroupsList[currentIdx + 1].name;

            // Scroll the input into view
            this.navScrollInputFieldIntoView();
        },

        // Scrolls into view the currently selected input field.
        navScrollInputFieldIntoView() {
            // If we have a current field in edit do nothing
            if (this.shortcutNav.crtFieldInEdit === true) {
                return;
            }

            // We select the form that has the scrolling
            const scrollingForm = this.$refs['vitalParamsForm'].$el;

            // We get the field that is currently selected
            const crtField = this.$refs[this.shortcutNav.crtField][0];

            // If we have a field and a scrolling form
            if (crtField != null && scrollingForm != null) {
                // We scroll the field into view
                // We subtract 85px because each field has a label before it
                scrollingForm.scrollTop = crtField.$el.offsetTop - 85;
            }
        },

        // Handles the key up events.
        handleKeyUps(event) {
            // If the dropdown is not open or the urgent popup is open do nothing
            if (this.getMustShowVitalParamsForm === false || this.mustShowUrgentPopup === true) {
                return;
            }

            switch (event.keyCode) {
                // Shift
                case 16:
                    if (this.shortcutNav.crtFieldInEdit === true) {
                        return;
                    }
                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                    // When pressing shift enable the keyboard navigation
                    if (!this.isNavAvailable) {
                        this.$emit('setIsKeyboardNav', true);
                    }

                    // We remove the border of the vital parameters form
                    this.shortcutNav.selectedDropdown = false;
                    break;
            }
        },

        // Handles the key down events.
        handleKeyDowns(event) {
            // If the dropdown is not open or the urgent popup is open do nothing
            if (this.getMustShowVitalParamsForm === false || this.mustShowUrgentPopup === true) {
                return;
            }

            // Get the current field
            let crtField;
            try {
                crtField = this.$refs[this.shortcutNav.crtField][0];
            } catch (e) {
                return;
            }
            switch (event.keyCode) {
                // Tab
                case 9:
                    // We usually prevent the default behavior for tab
                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();

                    break;

                // Alt
                case 18:
                    // We usually prevent the default behavior for alt
                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();

                    break;

                // Shift
                case 16:
                    if (this.shortcutNav.crtFieldInEdit === true) {
                        return;
                    }
                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();

                    // We add the border of the vital parameters form
                    this.shortcutNav.selectedDropdown = true;
                    break;

                // Escape
                case 27:
                    // We prevent the default behavior for escape (in this case closing the dropdown)
                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                    // If we don't have keyboard navigation enabled do nothing
                    if (!this.isNavAvailable) {
                        return;
                    }

                    if (this.shortcutNav.selectIsOpen === true && this.shortcutNav.crtField.indexOf(VITAL_PARAMS_GROUP_FIELD_SELECTOR_PREFIX) !== -1) {
                        crtField.hideMenu();
                        crtField.$el.blur();
                        this.shortcutNav.selectIsOpen = false;
                        return;
                    }

                    // If we have a current field in edit then submit the changed value and exit editing mode
                    if (this.shortcutNav.crtFieldInEdit === true) {
                        // If the current field value is different from the initial one
                        if (this.changedVitalParam !== null) {
                            // Submit the new value to the server
                            this.submitVitalParameter(this.changedVitalParam).then(() => {

                            });
                        }

                        if (this.changedVitalParamGroup !== null) {
                            this.submitVitalParameter({
                                name: this.changedVitalParamGroup.selectedVitalParamName,
                                value: this.changedVitalParamGroup.value
                            })
                        }
                        // We blur the input field
                        crtField.$refs.input.blur();
                        // We set the current field in edit to false
                        this.shortcutNav.crtFieldInEdit = false;
                        return;
                    }

                    // If we don't have a field in edit then close the dropdown
                    this.toggleDropdown();

                    break;

                // Arrow down
                case 40:
                    // If we have a current field in edit or a select open do nothing
                    if (this.shortcutNav.crtFieldInEdit === true || this.shortcutNav.selectIsOpen === true) {
                        return;
                    }

                    if (this.shortcutNav.crtFieldInEdit === false) {
                        // Prevents the default behavior
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                    }

                    // Down
                    if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {
                        // Select the next input field
                        this.navSelectNextInputField();
                    }

                    // CTRL + DOWN
                    if (event.shiftKey === false && event.altKey === false && event.ctrlKey === true) {
                        // Select the last input field.
                        this.navSelectLastInputField();
                    }

                    break;

                // Arrow up
                case 38:
                    // If we have a current field in edit or a select open do nothing
                    if (this.shortcutNav.crtFieldInEdit === true || this.shortcutNav.selectIsOpen === true) {
                        return;
                    }

                    if (this.shortcutNav.crtFieldInEdit === false) {
                        // Prevents the default behavior
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                    }

                    // Up
                    if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {
                        // Select the previous input field.
                        this.navSelectPreviousInputField();
                    }
                    // CTRL + UP
                    if (event.shiftKey === false && event.altKey === false && event.ctrlKey === true) {
                        // Select the first input field.
                        this.navSelectFirstInputField();
                    }

                    break;

                // ArrowLeft
                case 37:
                    // If we have a current field in edit or a select open do nothing
                    if (this.shortcutNav.crtFieldInEdit === true || this.shortcutNav.selectIsOpen === true) {
                        return;
                    }
                    // If we don't have keyboard navigation enabled then enable it.
                    if (!this.isNavAvailable) {
                        this.$emit('setIsKeyboardNav', true);
                    }
                    // Prevents the default behavior if we don't have a field in edit
                    if (this.shortcutNav.crtFieldInEdit === false) {
                        event.preventDefault();
                    }

                    // Left
                    if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {
                        // Select the input field to the left.
                        this.navSelectLeftField();
                    }

                    break;

                // ArrowRight
                case 39:
                    // If we have a current field in edit or a select open do nothing
                    if (this.shortcutNav.crtFieldInEdit === true || this.shortcutNav.selectIsOpen === true) {
                        return;
                    }
                    // If we don't have keyboard navigation enabled then enable it.
                    if (!this.isNavAvailable) {
                        this.$emit('setIsKeyboardNav', true);
                    }

                    // Prevents the default behavior if we don't have a field in edit
                    if (this.shortcutNav.crtFieldInEdit === false) {
                        event.preventDefault();
                    }

                    if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {
                        // Select the input field to the right.
                        this.navSelectRightField();
                    }
                    break;

                // PageUp
                case 33:
                    // Prevents the default scrolling behavior of the content
                    event.preventDefault();
                    // We scroll up 50px;
                    this.$refs["vitalParamsForm"].$el.scrollTop -= 50;

                    break;

                // PageDown
                case 34:
                    // Prevents the default scrolling behavior of the content
                    event.preventDefault();

                    // We scroll down 50px;
                    this.$refs["vitalParamsForm"].$el.scrollTop += 50;
                    break;

                // Enter
                case 13:


                    // ENTER
                    if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {

                        // If we have a field in edit then do nothing
                        if (this.shortcutNav.crtFieldInEdit === true) {
                           return;
                        }

                        // If we don't have a field in edit then enter editing mode
                        // If the current field is a select
                        if (this.shortcutNav.crtField.indexOf(VITAL_PARAMS_GROUP_FIELD_SELECTOR_PREFIX) !== -1) {
                            // Toggle the select
                            this.shortcutNav.selectIsOpen = !this.shortcutNav.selectIsOpen;
                            // If we are going to open the select
                            if (this.shortcutNav.selectIsOpen === true) {
                                // Show the menu and set the index to 0
                                crtField.$el.focus();
                                crtField.showMenu();
                                crtField.setMenuIndex(0);
                            }
                            else {
                                // If we are closing the select with enter
                                crtField.$el.blur();
                                // Select the current item
                                crtField.selectItem(crtField.menuItems[crtField.$refs.menu.listIndex]);
                                // Hide the menu
                                crtField.hideMenu();
                            }
                        }
                        else {
                            crtField.$refs.input.focus();
                            this.shortcutNav.crtFieldInEdit = true;
                        }


                    }

                    // CTRL + ENTER
                    else if (event.shiftKey === false && event.altKey === false && event.ctrlKey === true) {
                        // If we don't have a field in edit or a select is opened then do nothing
                        if (this.shortcutNav.selectIsOpen === true) {
                            return;
                        }

                        // If we don't have keyboard navigation enabled do nothing
                        if (!this.isNavAvailable && this.shortcutNav.crtFieldInEdit === true) {
                            this.$emit('setIsKeyboardNav', true);
                        }


                        // If we have a field in edit then submit the changed value and exit editing mode
                        if (this.changedVitalParam !== null) {
                            this.submitVitalParameter(this.changedVitalParam);
                        }

                        if (this.changedVitalParamGroup !== null) {
                            this.submitVitalParameter({
                                name: this.changedVitalParamGroup.selectedVitalParamName,
                                value: this.changedVitalParamGroup.value
                            })
                        }
                        // Exit editing mode
                        this.shortcutNav.crtFieldInEdit = false;
                        // Blur the input field
                        crtField.$refs.input.blur();
                    }
                    break;

                // M
                case 77:
                    // ALT + M
                    if (event.shiftKey === false && event.altKey === true && event.ctrlKey === false) {
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                    }
                    break;

                // P
                case 80:
                    // ALT + P
                    if (event.shiftKey === false && event.altKey === true && event.ctrlKey === false ) {
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                    }
                    break;

                // Q
                case 81:
                    // ALT + Q
                    if (event.shiftKey === false && event.altKey === true && event.ctrlKey === false ) {
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                    }
                    break;

                // S
                case 83:
                    // ALT + S
                    if (event.shiftKey === false && event.altKey === true && event.ctrlKey === false ) {
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                    }
                    break;

                // V
                case 86:
                    // ALT + V
                    if (event.shiftKey === false && event.altKey === true && event.ctrlKey === false) {
                        // Prevent the default behavior
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                    }
                    break;
            }
        },

        // Selects the input field on click
        handleInputFieldClicks(paramName) {
            // We set the current field to the clicked one
            this.shortcutNav.crtField = paramName;
            // We enter editing mode
            this.shortcutNav.crtFieldInEdit = true;
        }

        /*******************************
         ***   KEYBOARD NAVIGATION   ***
         ***        END CODE         ***
         *******************************/


    },

    watch: {
        getMustShowVitalParamsForm(newValue, oldValue) {
            // If we open the popup
            if (newValue === true) {
               if (this.getMustFocusVitalParameter) {
                   let mustFocusVitalParamField;
                   // If we must focus a vital parameter decide if its part of a group or not.
                   if (this.getFocusVitalParameter['group'] != null) {
                       mustFocusVitalParamField = VITAL_PARAMS_GROUP_INPUT_FIELD_PREFIX + this.getFocusVitalParameter['group'];
                   }
                   else {
                       mustFocusVitalParamField = VITAL_PARAMS_INPUT_FIELD_PREFIX + this.getFocusVitalParameter['name'];
                   }
                   let crtField = this.$refs[mustFocusVitalParamField];
                   if (crtField != null) {
                       this.shortcutNav.crtField = mustFocusVitalParamField;
                       crtField = crtField[0];
                       setTimeout(() => {
                            crtField.$refs.input.focus();
                       }, 100)
                   }

                   this.shortcutNav.crtFieldInEdit = true;
                   this.$store.commit('VitalParametersStore/setFocusVitalParameter', null);
               }
               // If this is the first time opening this popup, we set the current field to be the first field
               if (this.shortcutNav.crtField === null) {
                   this.shortcutNav.crtField = VITAL_PARAMS_INPUT_FIELD_PREFIX + this.vitalParamList[0].name;
                   this.shortcutNav.crtFieldInEdit = false;
               }
            }
        }
    }
}
</script>

<style lang="scss">
    .select-arrow-down {
        transition: all .5s ease;
    }
    .select-arrow-up {
        transform: rotate(180deg);
    }
</style>



// WEBPACK FOOTER //
// src/professional/components/shared/VitalParamsDropdownForm.vue